import { render } from "./app.vue?vue&type=template&id=c7406ada"
import script from "./app.vue?vue&type=script&lang=ts"
export * from "./app.vue?vue&type=script&lang=ts"

import "./app.vue?vue&type=style&index=0&id=c7406ada&lang=css"
script.render = render

export default script